// src/components/FounderSection.jsx
import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import { FaLinkedin, FaTwitter, FaInstagram } from "react-icons/fa";
import "./FounderSection.css";
import founderImg from "../assets/founder-1.jpeg"; // add your founder image here

const FounderSection = () => {
  return (
    <section className="founder-section py-5">
      <Container>
        <Row className="justify-content-center">
          <Col md={12} lg={12}>
            <Card className="founder-card text-center shadow-lg">
              <div className="founder-image">
                <img src={founderImg} alt="Founder" className="img-fluid rounded-circle" />
              </div>
              <Card.Body>
                <h3 className="founder-name">Masood Khan </h3>
                <p className="founder-role">Founder & Lead Consultant </p>
                <p className="founder-bio">
                 Masood is the driving force behind Strat Edge. With a background in project execution, technical troubleshooting, and digital innovation, he brings a methodical, results-driven approach to every engagement. His entrepreneurial spirit and commitment to excellence shape the company’s vision and values.

                </p>
                <div className="social-links">
                  <a href="https://linkedin.com" target="_blank" rel="noreferrer">
                    <FaLinkedin />
                  </a>
                  <a href="https://twitter.com" target="_blank" rel="noreferrer">
                    <FaTwitter />
                  </a>
                  <a href="https://instagram.com" target="_blank" rel="noreferrer">
                    <FaInstagram />
                  </a>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default FounderSection;
